export default __webpack_public_path__ + "static/media/dark_message_icon.2ee7085f.svg";